import { render, staticRenderFns } from "./PageEventClosed.vue?vue&type=template&id=2d4a4799&scoped=true"
import script from "./PageEventClosed.vue?vue&type=script&lang=js"
export * from "./PageEventClosed.vue?vue&type=script&lang=js"
import style0 from "./PageEventClosed.vue?vue&type=style&index=0&id=2d4a4799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a4799",
  null
  
)

export default component.exports